import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':accountId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:accountId`;

export const URL = (accountId: number): RouteDefinition => `${baseRoute}/${accountId}`;
